import { useEffect, useMemo, useState } from "react"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { O, PanelLoader, useGetCrumbs, useUIStateActions } from "../../../../../features/ui"
import { operationHelpers } from "../../../../operations"
import { Budget, Customer, HoardOrder } from "../../../state/types"
import { useCustomerLoaders } from "../../../loaders/customerLoaders"
import { useLocation, useNavigate } from "react-router-dom"
import { HoardForm } from "./hoardForm"
import { TableName } from "../../../../../tables"
import { useSaleOperationHooks } from "../../../hooks/saleOperationHooks"

export const HoardFormLoader = () => {
    const { tableName, dataType } = useRoutesHooks().parseUrl()
    const isHoard = tableName === TableName.HOARD_ORDERS
    const hoard = isHoard ? dataType as O<HoardOrder> : undefined
    const budget = !isHoard ? dataType as O<Budget> : undefined
    const hoardOrBudget = hoard || budget
    
    const [ready, setReady] = useState(false)
    const [customer, setCustomer] = useState<O<Customer>>()

    const { describeCode } = operationHelpers
    const { isEditable } = useSaleOperationHooks()
    const { getRoutePath } = useRoutesHooks()
    const { state } = useLocation()
    const navigate = useNavigate()

    const keepPrices = state?.keepPrices ?? false

    const customerLoaders = useCustomerLoaders()

    const { setDisableBranchSelector } = useUIStateActions()

    const load = async () => {
        if (hoard && !( await isEditable(hoard))) {
            navigate(getRoutePath(RoutePath.HOARDS, hoard.id))
        } else if (state?.customerId || hoardOrBudget) {
            const { loadCustomer } = customerLoaders()
            const loadedCustomer = await loadCustomer(state?.customerId || hoardOrBudget!.customerId)
            setCustomer(loadedCustomer)
        }
    }

    useEffect(() => {
        setDisableBranchSelector(true)
        load().then(() => setReady(true))
        return () => {
            setDisableBranchSelector(false)
        }
    }, [])

    const title = useMemo(() => `${hoard ? 'Editar' : 'Crear'} Acopio${hoard ? ' ' + describeCode(hoard) : ''}`, [hoard])
    const crumbs = useGetCrumbs(
        isHoard ? 'Acopios': 'Presupuestos',
        isHoard ? RoutePath.HOARDS : RoutePath.BUDGETS,
        hoardOrBudget && describeCode(hoardOrBudget),
        hoardOrBudget?.id,
        hoard ? 'Editar' : 'Crear' + (budget ? ' Acopio' : '')
    )

    return (
        <PanelLoader
            title={title}
            crumbs={crumbs}
            ready={ready}
            wide
        >
            <HoardForm
                hoard={hoard}
                budget={budget}
                customer={customer}
                keepPrices={keepPrices}
            />
        </PanelLoader>
    )
}
